<template>
  <client-only>
    <login-modal />
  </client-only>
</template>

<script setup lang="ts">
const LoginModal = defineAsyncComponent(() => dynamicImport(() => import('@/components/login/login-modal.vue'), 'login-modal'))
</script>
